(function () {
  'use strict';

  var HERO_IMAGES = [
    'https://cdn.shopify.com/s/files/1/0665/5737/files/carousel-21pack-box.jpg?v=1773420203',
    'https://cdn.shopify.com/s/files/1/0665/5737/files/STRIPS_META_AD_4x5-2.jpg?v=1773420040',
    'https://cdn.shopify.com/s/files/1/0665/5737/files/71C5Uo3D7PL._AC_SX679.jpg?v=1773695376',
    'https://cdn.shopify.com/s/files/1/0665/5737/files/81cVeVCd36L._AC_SX679.jpg?v=1773696073',
    'https://cdn.shopify.com/s/files/1/0665/5737/files/812bETpQRKL._AC_SX679.jpg?v=1773696073',
    'https://cdn.shopify.com/s/files/1/0665/5737/files/NHA_META_AD_4x5-2.jpg?v=1773422147',
    'https://cdn.shopify.com/s/files/1/0665/5737/files/NHA_META_AD_9x16-3.jpg?v=1773422368'
  ];

  var TOOTHPASTE_VARIANT_ID = 45466739834937;

  var TIERS = {
    starter: { price: 45, subPrice: 38.25 },
    popular: { price: 85, subPrice: 76.5 },
    best: { price: 115, subPrice: 97.75 }
  };

  var BUNDLES = {
    starter: {
      mainQty: 1,
      toothpasteQty: 1,
      otpDiscount: ["TOOTHPASTEFREE","1BOXDEAL"],
      subDiscount: ["TOOTHPASTEFREE","1BOXDEALSUB"]
    },

    popular: {
      mainQty: 2,
      toothpasteQty: 1,
      otpDiscount: ["TOOTHPASTEFREE","2BOXDEAL"],
      subDiscount: ["TOOTHPASTEFREE","2BOXDEALSUB"]
    },

    best: {
      mainQty: 3,
      toothpasteQty: 2,
      otpDiscount: ["2TOOTHPASTEFREE","3BOXDEAL"],
      subDiscount: ["2TOOTHPASTEFREE","3BOXDEALSUB"]
    }
  };

  var subs = { starter: false, popular: false, best: false };

  function money(value) {
    return '$' + Number(value).toFixed(2);
  }

  function scrollToOffer(event) {
    if (event) {
      event.preventDefault();
    }
    var offer = document.getElementById('offer');
    if (offer) {
      offer.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  function initScrollCtas() {
    document.querySelectorAll('[data-scroll-offer]').forEach(function (el) {
      el.addEventListener('click', scrollToOffer);
    });
  }

  function updateMidnightCountdown() {
    var now = new Date();
    var end = new Date(now);
    end.setHours(23, 59, 59, 999);
    var diff = end.getTime() - now.getTime();

    var hours = String(Math.floor(diff / (1000 * 60 * 60))).padStart(2, '0');
    var minutes = String(Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60))).padStart(2, '0');
    var seconds = String(Math.floor((diff % (1000 * 60)) / 1000)).padStart(2, '0');

    document.querySelectorAll('[data-midnight-unit="hours"]').forEach(function (el) { el.textContent = hours; });
    document.querySelectorAll('[data-midnight-unit="minutes"]').forEach(function (el) { el.textContent = minutes; });
    document.querySelectorAll('[data-midnight-unit="seconds"]').forEach(function (el) { el.textContent = seconds; });
  }

  function initHeroCountdownTimer() {
    var STORAGE_KEY = 'lumineuxBogoEndTime';
    var countdownEl = document.getElementById('hero-countdown-digits');
    if (!countdownEl) return;

    function getOrCreateEndTime() {
      var stored = window.localStorage.getItem(STORAGE_KEY);
      var endTime = stored ? new Date(Number(stored)) : null;
      if (!endTime || Number.isNaN(endTime.getTime()) || endTime.getTime() <= Date.now()) {
        endTime = new Date(Date.now() + 24 * 60 * 60 * 1000);
        window.localStorage.setItem(STORAGE_KEY, String(endTime.getTime()));
      }
      return endTime.getTime();
    }

    var endTimeMs = getOrCreateEndTime();

    function update() {
      var diff = endTimeMs - Date.now();
      if (diff <= 0) {
        endTimeMs = getOrCreateEndTime();
        diff = endTimeMs - Date.now();
      }

      var totalSeconds = Math.max(0, Math.floor(diff / 1000));
      var hours = String(Math.floor(totalSeconds / 3600)).padStart(2, '0');
      var minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, '0');
      var seconds = String(totalSeconds % 60).padStart(2, '0');

      countdownEl.textContent = hours + ':' + minutes + ':' + seconds;
    }

    update();
    window.setInterval(update, 1000);
  }

  function initStickyHeaderAndMobileCta() {
    var header = document.getElementById('site-header');
    var stickyCta = document.getElementById('sticky-cta');

    function onScroll() {
      var y = window.scrollY || window.pageYOffset;
      if (header) {
        header.classList.toggle('header--scrolled', y > 50);
      }
      if (stickyCta) {
        stickyCta.classList.toggle('sticky-cta--visible', y > 300);
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function initHeroThumbnailSwitcher() {
    var mainImg = document.getElementById('hero-main-image');
    var thumbnails = document.getElementById('hero-thumbnails');
    if (!mainImg || !thumbnails) return;

    thumbnails.addEventListener('click', function (event) {
      var button = event.target.closest('[data-hero-index]');
      if (!button) return;

      var index = Number(button.getAttribute('data-hero-index'));
      if (Number.isNaN(index) || !HERO_IMAGES[index]) return;

      mainImg.src = HERO_IMAGES[index];
      thumbnails.querySelectorAll('.hero-thumb').forEach(function (thumb) {
        thumb.classList.remove('hero-thumb-active');
      });
      button.classList.add('hero-thumb-active');
    });
  }

  function updateTierUi(tierId) {
    var card = document.querySelector('[data-tier-id="' + tierId + '"]');
    if (!card) return;

    var isSub = !!subs[tierId];
    var tier = TIERS[tierId];
    if (!tier) return;

    var price = isSub ? tier.subPrice : tier.price;

    var priceCurrent = card.querySelector('.price-current');
    var subBadge = card.querySelector('.price-sub-badge');
    var subDetails = card.querySelector('.subscribe-toggle-details');
    var buyButton = card.querySelector('[data-buy]');
    var toggle = card.querySelector('.toggle-switch');

    if (priceCurrent) {
      priceCurrent.textContent = money(price);
    }
    if (subBadge) {
      subBadge.hidden = !isSub;
    }
    if (subDetails) {
      subDetails.hidden = !isSub;
    }
    if (buyButton) {
      buyButton.textContent = 'Buy Now — ' + money(price) + ' →';
    }
    if (toggle) {
      toggle.classList.toggle('toggle-on', isSub);
    }
  }

  function initSubscribeToggles() {
    document.querySelectorAll('[data-toggle-sub]').forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var tierId = toggle.getAttribute('data-toggle-sub');
        if (!Object.prototype.hasOwnProperty.call(subs, tierId)) return;
        subs[tierId] = !subs[tierId];
        updateTierUi(tierId);
      });
    });

    Object.keys(subs).forEach(updateTierUi);
  }

  function initWhatDoIGetAccordions() {
    document.querySelectorAll('[data-toggle-details]').forEach(function (button) {
      button.addEventListener('click', function () {
        var tierId = button.getAttribute('data-toggle-details');
        var panel = document.querySelector('[data-details="' + tierId + '"]');
        if (!panel) return;

        var isHidden = panel.hidden;
        panel.hidden = !isHidden;
        button.setAttribute('aria-expanded', isHidden ? 'true' : 'false');
        button.textContent = isHidden ? 'Hide details ▲' : 'What do I get? ▼';
      });
    });
  }

  function trackAddToCart(tierId, value) {
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'add_to_cart', {
        offer_type: tierId,
        value: value,
        currency: 'USD'
      });
    }
  }

async function addToCartAndCheckout(card, tierId, isSub) {

  var variantId = card.getAttribute('data-variant-id');
  var sellingPlan = card.getAttribute('data-sub-plan');

  if (!variantId) return;

  var bundle = BUNDLES[tierId] || { mainQty:1, toothpasteQty:0 };

  try {

    await fetch('/cart/clear.js', {
      method: 'POST',
      headers: {
        'Accept': 'application/json'
      }
    });

    var items = [
      {
        id: variantId,
        quantity: bundle.mainQty
      }
    ];

    if (isSub && sellingPlan) {
      items[0].selling_plan = sellingPlan;
    }

    if (bundle.toothpasteQty > 0) {
      items.push({
        id: TOOTHPASTE_VARIANT_ID,
        quantity: bundle.toothpasteQty
      });
    }

    await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ items: items })
    });

    var discounts = isSub ? bundle.subDiscount : bundle.otpDiscount;
    var discountString = Array.isArray(discounts) ? discounts.join(',') : discounts;
    
    if (discountString) {
      window.location.href = '/checkout?discount=' + discountString;
    } else {
      window.location.href = '/checkout';
    }

  } catch(e) {
    console.error(e);
    window.location.href = '/cart';
  }
}

    function initBuyNow() {
      document.querySelectorAll('[data-buy]').forEach(function (button) {
        button.addEventListener('click', async function () {

          if (button.classList.contains('is-processing')) return;

          button.classList.add('is-processing');
          button.dataset.originalText = button.textContent;
          button.textContent = "Processing...";
          button.disabled = true;

          var tierId = button.getAttribute('data-buy');
          var card = document.querySelector('[data-tier-id="' + tierId + '"]');
          if (!card || !TIERS[tierId]) return;

          var isSub = !!subs[tierId];
          var value = isSub ? TIERS[tierId].subPrice : TIERS[tierId].price;

          trackAddToCart(tierId, value);

          try {
            await addToCartAndCheckout(card, tierId, isSub);
          } catch (error) {

            console.error(error);

            /* restore button if something fails */
            button.textContent = button.dataset.originalText;
            button.disabled = false;
            button.classList.remove('is-processing');

          }
        });
      });
    }

  updateMidnightCountdown();
  window.setInterval(updateMidnightCountdown, 1000);

  initScrollCtas();
  initHeroCountdownTimer();
  initStickyHeaderAndMobileCta();
  initHeroThumbnailSwitcher();
  initSubscribeToggles();
  initWhatDoIGetAccordions();
  initBuyNow();
})();